import React from 'react'; //{ useEffect, useRef, createContext, useState }
import { useSelector, } from 'react-redux';
// import { useParams } from 'react-router-dom';

function ViewPassPortGuest(props) {
    const makeRoomOnState = useSelector(state => state.makeRoom);
    const { listGuestSelect, indexGuestSelect } = makeRoomOnState;
    const linkPassPortDefault = "/img/passport/avatar.png";
    const passportBaseUrl = 'https://database.azumayareport.com';
    const passportPath = listGuestSelect[indexGuestSelect]?.passport || '';

    const getPassportUrl = (path) => {
        if (!path) return `${passportBaseUrl}${linkPassPortDefault}`;
        if (path.startsWith('http://') || path.startsWith('https://')) return path;
        return `${passportBaseUrl}${path}`;
    };

    return (<div style={{ flex: 1, width: '50%', }}>
        <h2 style={{ border: '1px solid black' }}>View Full Pass Port</h2>
        {
            listGuestSelect.length > 0 && <div style={{height:'710px',overflow:'scroll',position:'relative'}}>
            <img
                src={`${getPassportUrl(passportPath)}?v=${new Date().getTime()}`}
                alt="passport"
                style={{width:'100%'}}
            ></img>
        </div>
        } 
    </div>)
}

export default ViewPassPortGuest
